<template>
  <div
    class="hero w-full h-screen desktop-bg relative overflow-hidden cityOfflineGameBackground"
  >
    <!--<img src="@/assets/emozgo/world.svg"-->
    <!--class="absolute select-none hide-element"-->
    <!--alt style="height: 130vh; transform: translateX(95%) translateY(-10%)" >-->
    <div
      class="flex justify-between items-center card-container lg:pl-0 xl:pl-0 mx-auto pt-5"
      id="header"
    >
      <div
        class="flex justify-between w-full"
        :class="[ isPhone === 'mobile' ? 'items-center' : 'items-start' ]"
      >
      <div class="flex" :class="[isPhone === 'desktop' ? 'flex-row' : 'flex-col items-start mt-4 mr-4']">
        <div>
          <a href="">
          <img
            src="@/assets/SVG/logo_white.svg"
            @click="$router.push('/')"
            class="w-32 lg:w-40 xl:w-40 z-10 cursor-pointer mr-10"
            alt
          />
        </a>
        </div>
        <div class="relative">
          <StubCity
            v-if="isPhone === 'desktop'"
            class="z-20 mt-1"
        ></StubCity>
        </div>
        </div>

        <!-- burger and show city for mobile  -->
        <div class="relative flex">
          <!-- profile logo-->
<!--          <div class="lg:hidden md:hidden pt-2 mr-2">-->
<!--            <UserModal-->
<!--              @logout="$emit('logout')"-->
<!--              @registration_open="$emit('auth')"-->
<!--              borderColor="text-white"-->
<!--              isPhone="isPhone"-->
<!--            ></UserModal>-->
<!--          </div>-->

          <div
            class="lg:hidden md:hidden flex justify-end flex-col relative ml-auto pb-2"
            style="width:20px"
          >
            <img
              class="lg:hidden md:hidden w-8 h-8 ml-auto mr-0 cursor-pointer pt-2"
              src="@/assets/SVG/burger_white.svg"
              alt
              @click.prevent="burgerMenuOpen"
            />
          </div>
          <!-- show city for mobile -->
          <div class="absolute" style="right:0;top:60px">
            <StubCity
              v-if="isPhone === 'mobile'"
            ></StubCity>
          </div>
        </div>
      </div>

      <div class="items-center text-sm z-50 relative hide-element">
        <div>
          <nav class="-mx-2 lex items-center inline-flex whitespace-no-wrap">
            <a
              href="https://party.mozgo.com/"
              class="text-main-text mx-2 hover:opacity-75 no-underline opacity-100 font-bold outline-none whitebackground"
              style="transition: all 0.5s"
              >MozgoParty</a
            >

            <a href="https://partners.mozgo.com/?utm_source=mozgocom">
              <button
                class="text-main-text mx-2 hover:opacity-75 opacity-100 font-bold outline-none whitebackground"
                style="transition: all 0.5s"
              >
                Купить франшизу
              </button>
            </a>
            <a
              href="https://corp.mozgo.com?utm_source=mozgo"
              class="text-main-text mx-2 hover:opacity-75 opacity-100 font-bold outline-none no-underline whitebackground"
              style="transition: all 0.5s"
              >Заказать корпоратив</a
            >
            <a
              href="https://basemozgo.notion.site/Mozg-d69190a80a684e0c9c0f5dbd7a07847b"
              class="text-main-text mx-2 hover:opacity-75 opacity-100 font-bold outline-none no-underline whitebackground "
              v-if="city == 'Екатеринбург'"
              style="transition: all 0.5s"
              >Вакансии</a
            >
            <!-- user modal desktop -->
<!--            <UserModal-->
<!--              @logout="$emit('logout')"-->
<!--              @registration_open="$emit('auth')"-->
<!--              borderColor="border-white"-->
<!--            ></UserModal>-->
          </nav>
        </div>
      </div>
    </div>

    <div
      class="card-container  lg:pl-0 xl:pl-0 text-center h-full mx-auto flex justify-start items-center content-center"
    >
      <div
        class="text-left text-2xl lg:text-5xl -mt-28 font-bold text-brand-darker w-full whitebackground"
      >
      <p>Мозгобойня – самая<br />масштабная и умная игра!</p>
        <!--
        <ul class="counter flex flex-row mt-6">
                        <li class="">
                            <h3 class="text-xl lg:text-3xl xl:text-3xl">{{ counter.countries }}</h3>
                            <p class="xl:text-lg lg:text-lg text-mxs">стран</p>
                        </li>
                        <li>
                            <h3 class="text-xl lg:text-3xl xl:text-3xl">{{ counter.cities }}</h3>
                            <p class="xl:text-lg lg:text-lg text-mxs pr-2">город</p>
                        </li>
                        <li class="whitespace-no-wrap -ml-2">
                            <h3 class="text-xl lg:text-3xl xl:text-3xl">{{ counter.players }} 000</h3>
                            <p class="xl:text-lg lg:text-lg text-mxs">игроков в месяц</p>
                        </li>
        </ul>-->

        <p
          class="text-xs md:text-lg text-main-text font-normal mt-6 whitebackground"
        >
          Мозгобойня - командная игра с вопросами и ответами в барах
          <br />и ресторанах твоего города.
        </p>


        <!-- <p class="mt-8 text-13px lg:text-lg xl:text-lg font-light w-4/5  whitespace-no-wrap">

     Встречайтесь с друзьями чаще,<br class="md:hidden lg:hidden xl:lg:hidden"> становитесь ближе<br class="hide-element">
        и открывайте для себя<br class="md:hidden lg:hidden xl:lg:hidden"> новое.
        Мозгобойня – это<br class="hide-element"> командная игра<br class="md:hidden lg:hidden xl:lg:hidden"> в вопросы и ответы
         в барах и ресторанах<br> твоего города.

        </p>-->

        <div class="w-full flex justify-start mt-8 md:flex-row flex-col">

          <!-- if the city has offline games -->

          <button
            class="offline-game-city-button py-3 font-semibold cursor-pointer text-base lg:text-lg xl:text-lg bg-brand-yellow rounded-full hover-up outline-none mr-0 md:mr-10 pr-4 pl-4"
            @click="$emit('scrollInto', 'upcoming_games')"
          >
            <!-- @click="$emit('scrollInto', 'upcoming_games')"  -->
            Сыграть в заведении
          </button>
          <!-- only for Yekaterinburg-->
          <button class="offline-game-city-button mt-3 md:mt-0 py-3 font-semibold cursor-pointer text-base lg:text-lg no-underline xl:text-lg bg-white rounded-full hover-up outline-none mr-0 md:mr-10 pr-4 pl-4"
                  @click="joinChat"
                  v-if="city === 'Екатеринбург'">
            Найти команду легко!
          </button>

          <div class="online-game-arrow text-base flex mt-4 md:mt-0 hoverUp " v-if="city !== 'Екатеринбург'" @click="toLive">
            <p>Сыграть онлайн</p>
            <img class="h-6 my-auto" src="@/assets/SVG/online-game-arrow.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="fw-down">
      <font-awesome-icon
        :icon="['fal', 'angle-down']"
        class="text-white text-6xl cursor-pointer tap-no-bgr arrow"
        @click="$emit('scrollInto', 'upcoming_games')"
      ></font-awesome-icon>
        </div>
    <desktop-menu
      v-if="desktop_menu"
      @close="burgerMenuOpen"
      @logout="$emit('logout')"
      @registration_open="$emit('auth')"
      class="lg:hidden"
    ></desktop-menu>


    <!-- <div v-if="cityLink" class="social-network absolute hide-element">
      <a v-if="isVk" class="" :href="cityLink"><img class="" src="@/assets/SVG/vk.svg"></a>
      <a v-else class="" :href="cityLink"><img class="" src="@/assets/SVG/facebook.svg"></a>
    </div>-->
  </div>
</template>

<script>
import isMobile from '../../mixins/isMobile';
import UserModal from '../../helpers/user-modal.vue';
import SelectCity from '../stub/stub_city_select.vue';
import StubCity from '../stub/stub_city.vue';
import DesktopMenu from './components/desktop-menu.vue';

export default {
  mixins: [isMobile],
  name: 'home-head',
  components: {
    DesktopMenu,
    SelectCity,
    UserModal,
    StubCity,
  },
  props: ['cityLink'],
  mounted() {
    (() => {
      const max = this.counterMax;
      Object.keys(this.counter).forEach((item) => {
        const timeout = setInterval(() => {
          if (this.counter[item] === max[item]) {
            clearInterval(timeout);
            return null;
          }
          this.counter[item] += this.counterStep[item];
          return null;
        }, 10);
      });
    })();
  },
  methods: {
    toLive() {
      window.location.href = process.env.VUE_APP_MOZGO_LIVE;
    },
    toParty() {
      window.location.href = process.env.VUE_APP_MOZGO_PARTY;
    },
    burgerMenuOpen() {
      this.desktop_menu = !this.desktop_menu;
      const body = document.getElementsByTagName('body');
      if (this.desktop_menu === true) body[0].classList.add('body-modal-open');
      if (this.desktop_menu === false) { body[0].classList.remove('body-modal-open'); }
    },
    joinChat() {
      window.open('https://t.me/+5xWnzVZwZZwyNmIy', '_blank');
    },
  },
  computed: {
    isPhone() {
      return this.isMobile;
    },
    isVk() {
      return this.cityLink ? this.cityLink.includes('vk.com') : false;
    },
    city() {
      return this.$store.getters.cityProps.city || '';
    },
  },
  data() {
    return {
      desktop_menu: false,
      showCity: false,
      counterMax: {
        countries: 17,
        cities: 251,
        players: 80,
      },
      counterStep: {
        countries: 1,
        cities: 1,
        players: 1,
      },
      counter: {
        countries: 0,
        cities: 0,
        players: 0,
      },
    };
  },
};
</script>

<style lang="less" scoped>
.hoverUp {
  transition: all 0.5s;
  &:hover {
    transform: translateY(-3px);
  }
}
.round {
  border-radius: 20px;
  border-width: 1px;
  width: 1.7em;
  height: 1.7em;
}

.tap-no-bgr {
  -webkit-tap-highlight-color: transparent;
}
.cityOfflineGameBackground {
  background: url(../../assets/main_background_city_offlineGame.png) !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
}
.whitebackground {
  color: #ffffff !important;
}
.arrow-down {
  position: absolute;
  bottom: 0rem;
  height: 7rem;
  display: grid;
  place-content: center;
}

.offline-game-city-button{
  color:#333333;
  width:340px;
}
.fw-down {
  position: absolute;
  bottom: 2rem;
  width: 100%;
  display: grid;
  place-content: center;
}
.social-network {
  right: 9.7%;
  bottom: 7.1%;
}
.no-webp .hero {
  background: url("../../assets/bg-first-qurantine.png");
  background-size: cover;
}
.webp .hero {
  background: url("../../assets/bg-first-qurantine.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.counter {
  list-style: none;
  padding-left: 0rem;
}

ul.counter > li {
  display: inline-block;
  margin-right: 3rem;
  text-align: left;
}

.counter ul {
  @apply w-full;
}

.counter h3 {
  @apply text-4xl text-brand-yellow font-extrabold;
}
.counter p {
  @apply text-lg;
}
.online-game-arrow p{
  cursor: pointer;
  display: grid;
  place-content: center;
  margin-right: 10px;
}
.online-game-arrow img{
  cursor: pointer;
}
.card-container {
  max-width: 80%;
}

@media (max-width: 767px) {
  .hide-element {
    display: none;
  }
  .hero {
    background: url("../../assets/bg-first-mobile-quarantine.png") !important;
    background-size: contain !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
  }
  .cityOfflineGameBackground {
    background: url(../../assets/SVG/main_background_city_offlineGame_mobile.svg) !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
  }
}
@media only screen and (min-width: 992px) {
  .desktop-bg {
    background-image: linear-gradient(153.22deg, #4a0045 0%, #bd006c 114.19%);
  }
}
@media only screen and (min-width: 1200px) {
  .desktop-bg {
    background-image: linear-gradient(153.22deg, #4a0045 0%, #bd006c 114.19%);
  }
}


@media (min-width: 768px) and (max-width: 1240px) {
  .counter li {
    @apply mr-4 mt-2 z-20  relative !important;
    border-radius: 10px;
  }
  50% {
    bottom: 3%;
  }
  100% {
    bottom: 7%;
  }
}


// @media only screen and (min-width: 319px) and (max-width: 330px) {
//   .card-container {
//     max-width: 290px;
//   }
// }

// @media only screen and (min-width: 400px) and (max-width: 600px) {
//   .card-container {
//     max-width: 380px;
//   }
// }
// @media only screen and (min-width: 330px) and (max-width: 400px) {
//   .card-container {
//     max-width: 330px;
//   }
// }

// @media only screen and (min-width: 600px) and (max-width: 767px) {
//   .card-container {
//     max-width: 345px;
//   }
// }


@media (max-width: 768px) {
  .hide-element {
    display: none;
  }
  .hero {
    background: url("../../assets/bg-first-mobile-quarantine.png") !important;
    background-size: cover !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
  }
  .cityOfflineGameBackground {
    background: url(../../assets/SVG/main_background_city_offlineGame_mobile.svg) !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
  }
    .online-game-arrow p{
    margin-left: auto;
  }
  .online-game-arrow img{
    margin-right: auto;
  }
  .card-container {
    max-width: 90%;
  }
  .fw-down{
    bottom: 4rem;
  }
}

@media (max-width: 767px) {
  .hide-element {
    display: none;
  }
  .fw-down {
    margin-bottom: 5rem;
  }
}

.fw-down {
  animation: arrow 1s linear infinite;
  animation-direction: alternate;
}
@keyframes arrow {
  0% {
    bottom: 2%;
  }
  100%{
    bottom: 1%;
  }

}

@media (min-width: 768px) and (max-width: 1240px) {
  .counter li {
    @apply mr-4 mt-2 z-20  relative !important;
    border-radius: 10px;
  }
  100% {
    bottom: 6%;
  }
}
@media (max-width: 767px) {
.offline-game-city-button{
  width: 100%;
}
}

@media (max-width: 321px) {
.fw-down{
  margin-bottom: 2rem;
}
}
</style>
